import { render, staticRenderFns } from "./addCapital.vue?vue&type=template&id=757c583c&scoped=true&"
import script from "./addCapital.vue?vue&type=script&lang=js&"
export * from "./addCapital.vue?vue&type=script&lang=js&"
import style0 from "./addCapital.vue?vue&type=style&index=0&id=757c583c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757c583c",
  null
  
)

export default component.exports